import { Component, OnInit, Input } from '@angular/core'; 
import { OperationsService } from '../../_services/operations.service';

@Component({
  selector: 'app-duerepayments',
  templateUrl: './duerepayments.component.html',
  styleUrls: ['./duerepayments.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class DuerepaymentsComponent implements OnInit {

  @Input('currentUser') currentUser:any;
  @Input('repayments') repayments: any;
  public showingSummary = false;
  constructor(public operationsService:OperationsService) { }
  showsum() {
    this.showingSummary = false;
  }
  ngOnInit() {
    this.getDueRepayments();
  }

  getDueRepayments(){
    this.operationsService.getDueRepaymentss(this.currentUser.token)
      .subscribe(data => {
       this.repayments = data.REPAYMENTS;

      });
  }


}
